import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "scrape"
}
const _hoisted_2 = {
  key: 0,
  class: "task-id"
}
const _hoisted_3 = {
  key: 1,
  class: "status"
}
const _hoisted_4 = { class: "status" }
const _hoisted_5 = { class: "actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_Icon = _resolveComponent("Icon")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_Button = _resolveComponent("Button")

  return ($data.loading)
    ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode(" Loading"),
          _createElementVNode("br", null, null, -1 /* HOISTED */),
          _createTextVNode(" Please wait... ")
        ])),
        _: 1 /* STABLE */
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($data.task_setting)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Task: " + _toDisplayString($data.task_setting.type) + "/" + _toDisplayString($data.task_setting.id), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        ($options.date)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Created at: " + _toDisplayString($options.date), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, [
            _cache[2] || (_cache[2] = _createTextVNode(" Status: ")),
            _createElementVNode("span", {
              class: _normalizeClass({err: $options.task_status === 'failed'})
            }, _toDisplayString($options.task_status || 'never launched'), 3 /* TEXT, CLASS */)
          ]),
          (!!$data.task_data?.error)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                content: "Error copied to clipboard",
                placement: "top",
                effect: "light",
                visible: _ctx.show_copy_ttip
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    stroke: "var(--gray-700)",
                    icon: "clipboard",
                    "stroke-width": "1",
                    width: "1.6rem",
                    height: "1.6rem",
                    class: "pointer",
                    onClick: _cache[0] || (_cache[0] = $event => ($options.copyError()))
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["visible"]))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Button, {
            primary: "",
            disabled: !$options.can_run,
            green: "",
            onClick: $options.scrape
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Scrape")
            ])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled", "onClick"]),
          _createVNode(_component_Button, {
            disabled: !$options.can_run,
            green: "",
            onClick: $options.cleanup
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Cleanup")
            ])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled", "onClick"])
        ])
      ]))
}